// extracted by mini-css-extract-plugin
export default {"buttLeft":"buttons-module__buttLeft__OFWiW","buttRight":"buttons-module__buttRight__ICT5d","disabled":"buttons-module__disabled__ZslJl"};